import {
  BarChart3,
  ClipboardList,
  CreditCard,
  FileInput,
  Handshake,
  LayoutTemplate,
  Mail,
  Megaphone,
  QrCode,
  ScanLine,
  Shield,
  Sparkles,
  Ticket,
  Users,
  Wallet,
  Webhook,
  Video,
} from "lucide-react";

const ICONS = {
  ticket: Ticket,
  layout: LayoutTemplate,
  mail: Mail,
  form: FileInput,
  qr: QrCode,
  wallet: Wallet,
  scan: ScanLine,
  hybrid: Video,
  chart: BarChart3,
  api: Webhook,
  users: Users,
  shield: Shield,
  operations: ClipboardList,
  megaphone: Megaphone,
  pricing: CreditCard,
  handshake: Handshake,
  sparkles: Sparkles,
};

export default function FeatureIcon({ name, size = 20, className = "" }) {
  const Icon = ICONS[name] || Sparkles;
  return <Icon size={size} strokeWidth={1.6} className={className} aria-hidden />;
}
